import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MoveItemToItemLocationMutationVariables = Types.Exact<{
  item_id: Types.Scalars['ID'];
  to_location_id: Types.Scalars['ID'];
}>;


export type MoveItemToItemLocationMutation = { __typename?: 'Mutation', changeItemLocation: boolean };


export const MoveItemToItemLocationDocument = gql`
    mutation MoveItemToItemLocation($item_id: ID!, $to_location_id: ID!) {
  changeItemLocation(item_id: $item_id, to_location_id: $to_location_id)
}
    `;
export type MoveItemToItemLocationMutationFn = Apollo.MutationFunction<MoveItemToItemLocationMutation, MoveItemToItemLocationMutationVariables>;

/**
 * __useMoveItemToItemLocationMutation__
 *
 * To run a mutation, you first call `useMoveItemToItemLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveItemToItemLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveItemToItemLocationMutation, { data, loading, error }] = useMoveItemToItemLocationMutation({
 *   variables: {
 *      item_id: // value for 'item_id'
 *      to_location_id: // value for 'to_location_id'
 *   },
 * });
 */
export function useMoveItemToItemLocationMutation(baseOptions?: Apollo.MutationHookOptions<MoveItemToItemLocationMutation, MoveItemToItemLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveItemToItemLocationMutation, MoveItemToItemLocationMutationVariables>(MoveItemToItemLocationDocument, options);
      }
export type MoveItemToItemLocationMutationHookResult = ReturnType<typeof useMoveItemToItemLocationMutation>;
export type MoveItemToItemLocationMutationResult = Apollo.MutationResult<MoveItemToItemLocationMutation>;
export type MoveItemToItemLocationMutationOptions = Apollo.BaseMutationOptions<MoveItemToItemLocationMutation, MoveItemToItemLocationMutationVariables>;